import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { IHttpServiceConfig, IHttpMethodConfig } from './types';

let axiosInstance: AxiosInstance;
let globalConfig: IHttpServiceConfig;

export function createAxiosInstance(config: IHttpServiceConfig): AxiosInstance {
	globalConfig = config;
	axiosInstance = axios.create({
		baseURL: config.baseUrl,
		timeout: 60000,
	});

	axiosInstance.interceptors.request.use(
		(config: InternalAxiosRequestConfig) => {
			const token = globalConfig.getToken?.();
			if (token) {
				config.headers?.set?.('Authorization', token);
			}
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	return axiosInstance;
}

export async function getRecaptchaToken(action: string, recaptchaSecret?: string): Promise<string> {
	if (!recaptchaSecret || typeof window === 'undefined') {
		return '';
	}

	try {
		const token = await (window as any).grecaptcha.execute(recaptchaSecret, { action });
		return token;
	} catch (error) {
		console.error('Error getting recaptcha token:', error);
		return '';
	}
}

export function handleError(error: any): never {
	if (error.response) {
		throw error.response;
	}
	throw error;
}
